module.exports = __webpack_public_path__ + "img/70m4.36f9e480.jpg";